<template>
    <div class="p-3 Animation_wrapper">
        <div class="mb-3">
            <div class="mb-3 ">
                <AnimationDropdown :isActive="getActiveObj.isInAnimationActive" title="In animation"
                    :animationList="animationListIn" animateType="IN" class="" :isdisabled="disbledinanimation" />
                <IncedecInput :defValue="getActiveObj.animationDelayIn" :getValue="setanimationDelayIn"
                    paddingClass="px-0" marginClass="mt-3" label="In Animation Start" sublabel="(SECONDS)"
                    :disabled="!getActiveObj.isInAnimationActive" />
                <IncedecInput :defValue="getActiveObj.animationDurationIn" :getValue="setanimationDurationIn"
                    paddingClass="px-0" marginClass="mt-3" label="DURATION" sublabel="(SECONDS)"
                    :disabled="!getActiveObj.isInAnimationActive" />
            </div>
            <div class="line">
                <hr>
            </div>
            <div class="mb-3">
                <AnimationDropdown :isActive="getActiveObj.isOutAnimationActive" title="out animation"
                    :animationList="animationListOut" animateType="OUT" class="mb-2"
                    :isdisabled="disabledOutAnimation" />
                <IncedecInput ref="outAnimationInput" :defValue="getActiveObj.animationDelayOut"
                    :getValue="setanimationDelayOut" paddingClass="px-0" marginClass="mt-3" label="Out Animation Start"
                    sublabel="(SECONDS)" :disabled="!getActiveObj.isOutAnimationActive" />
                <IncedecInput :defValue="getActiveObj.animationDurationOut" :getValue="setanimationDurationOut"
                    paddingClass="px-0" marginClass="mt-3" label="DURATION" sublabel="(SECONDS)"
                    :disabled="!getActiveObj.isOutAnimationActive" />
            </div>
            <div class="line">
                <hr>
            </div>
            <AnimationDropdown :isActive="getActiveObj.isLoopAnimationActive" title="effects" animateType="LOOP"
                :animationList="animationListLoop" :isdisabled="disabledLoopAnimation" @change="isLoopAnimation($event)"
                :checked="getActiveObj.animationLoop" />
            <IncedecInput :defValue="getActiveObj.animationLoopDuration" :getValue="setanimationLoopDuration"
                paddingClass="px-0" marginClass="mt-3" label="Speed" sublabel="(SECONDS)"
                :disabled="!getActiveObj.isLoopAnimationActive" />
            <!-- <div class="form-group mt-3">
                <b-form-checkbox
                id="checkbox-1"
                name="checkbox-1"
                @change="isLoopAnimation($event)"
                :checked="getActiveObj.animationLoop"
            >
                Loop Animation
            </b-form-checkbox>

            </div>     -->
            <!-- <IncedecInput paddingClass="px-0" marginClass="mt-3"  label="SLIDE DURATION" sublabel="(SECONDS)" :disabled="!loopanimation"  /> -->
        </div>
    </div>
</template>

<script>
import AnimationDropdown from '@/utils/AnimationDropdown.vue';
import IncedecInput from '../incedecInput.vue';
import debounce from 'lodash.debounce';

export default {
    name: "AnimationTab",
    components: {
        AnimationDropdown,
        IncedecInput
    },
    data() {
        return {
            checkIsInAnimationActive: false,
            disabledinanimation: false,
            outanimation: false,
            loopanimation: false,
            currentAnimation: '', // Holds the active animation class
            isAnimating: false, // Prevents triggering multiple animations simultaneously

            animationListIn: [
                "bounceIn",
                "bounceInDown",
                "bounceInLeft",
                "bounceInRight",
                "bounceInUp",
                "fadeIn",
                "fadeInDown",
                "fadeInDownBig",
                "fadeInLeft",
                "fadeInLeftBig",
                "fadeInRight",
                "fadeInRightBig",
                "fadeInUp",
                "fadeInUpBig",
                "flipInX",
                "flipInY",
                "lightSpeedIn",
                "rollIn",
                "rotateIn",
                "rotateInDownLeft",
                "rotateInDownRight",
                "rotateInUpLeft",
                "rotateInUpRight",
                "slideInDown",
                "slideInLeft",
                "slideInRight",
                "slideInUp",
                "zoomIn",
                "zoomInDown",
                "zoomInLeft",
                "zoomInRight",
                "zoomInUp"
            ],
            animationListOut: [
                "bounceOut",
                "bounceOutDown",
                "bounceOutLeft",
                "bounceOutRight",
                "bounceOutUp",
                "fadeOut",
                "fadeOutDown",
                "fadeOutDownBig",
                "fadeOutLeft",
                "fadeOutLeftBig",
                "fadeOutRight",
                "fadeOutRightBig",
                "fadeOutUp",
                "fadeOutUpBig",
                "flipOutX",
                "flipOutY",
                "lightSpeedOut",
                "rollOut",
                "rotateOut",
                "rotateOutDownLeft",
                "rotateOutDownRight",
                "rotateOutUpLeft",
                "rotateOutUpRight",
                "slideOutDown",
                "slideOutLeft",
                "slideOutRight",
                "slideOutUp",
                "slideOutRight",
                "zoomOut",
                "zoomOutDown",
                "zoomOutLeft",
                "zoomOutRight",
                "zoomOutUp",
            ],
            animationListLoop: [
                "bounce",
                "flash",
                "flip",
                "headShake",
                "hinge",
                "jello",
                "pulse",
                "rubberBand",
                "shake",
                "swing",
                "tada",
                "wobble"
            ],

        }
    },
    computed: {
        getActiveObj() {
            return this.$store.getters.getActiveObjectprops
        },
    },
    watch: {
        getActiveObj: {
            handler(updatedValues) {
                debugger // eslint-disable-line no-debugger

                // this.lineheight = updatedValues.lineHeight;
                this.borderRadius = updatedValues.borderRadius;
                // if(updatedValues.animationClassIn !== "") {
                //     updatedValues.isInAnimationActive = true
                // // } else {
                // //     updatedValues.isInAnimationActive = false;
                // // } 

                // // if(updatedValues.animationClassOut !== "") {
                //     updatedValues.isOutAnimationActive = true
                // // } else {
                // //     updatedValues.isOutAnimationActive = false
                // // }

                // // if(updatedValues.animationClassLoop !== "") {
                //     updatedValues.isLoopAnimationActive = true
                // // } else {
                //     updatedValues.isLoopAnimationActive = false
                // }

            },
            deep: true,
            immediate: true
        }
    },
    methods: {

        triggerAnimation() {
            if (this.isAnimating) return; // Prevent multiple triggers

            const animationType = this.getActiveObj.selectedAnimationType; // Get active animation type
            if (!animationType) {
                alert("Please select an animation type to preview!");
                return;
            }

            // Set the current animation
            this.currentAnimation = animationType;
            this.isAnimating = true;

            // Remove the animation class after the animation ends
            setTimeout(() => {
                this.currentAnimation = '';
                this.isAnimating = false;
            }, 1000); // Adjust this based on animation duration
        },
        onAnimationEnd() {
            this.isAnimating = false; // Reset animation flag
        },
        setanimationDelayIn(value) {
            this.$store.dispatch("setCurrentObjectProperties", { animationDelayIn: parseInt(value) });
        },
        setanimationDurationIn(value) {
            this.$store.dispatch("setCurrentObjectProperties", { animationDurationIn: parseInt(value) });
        },
        // setanimationDelayOut(value) {
        //     const animationDelayIn = this.getActiveObj.animationDelayIn;

        //     if (parseInt(value) <= animationDelayIn) {
        //         alert("Out Animation Start must be greater than In Animation Start.");
        //         this.$store.dispatch("setCurrentObjectProperties", { animationDelayOut: parseInt(animationDelayIn) + 1 });

        //         // Force input value sync
        //         this.$nextTick(() => {
        //             this.$refs.outAnimationInput.value = parseInt(animationDelayIn) + 1; // Reference to IncedecInput
        //         });

        //         return false; // Prevent further updates
        //     }

        //     // Update the store with valid value
        //     this.$store.dispatch("setCurrentObjectProperties", { animationDelayOut: parseInt(value) });
        //     return true; // Allow updates
        // },

        setanimationDelayOut: debounce(function (value) {
            if (!value || isNaN(parseInt(value))) return;

            const delayOut = parseInt(value);
            const animationDelayIn = this.getActiveObj.animationDelayIn || 0;
            const animationDurationIn = this.getActiveObj.animationDurationIn || 0;
            const animationClassIn = this.getActiveObj.animationClassIn;
            const animationClassOut = this.getActiveObj.animationClassOut;

            const totalInDuration = animationDelayIn + animationDurationIn;

            if (animationClassIn !== "") {
                if (delayOut <= animationDelayIn) {
                    console.log("Out Animation Start must be greater than In Animation Start.");
                    return;
                }

                if (animationClassOut !== "" && delayOut <= totalInDuration) {
                    console.log("Out Animation must start after In Animation completes.");
                    return;
                }
            }

            this.$store.dispatch("setCurrentObjectProperties", {
                animationDelayOut: delayOut,
                isOutDelayManuallySet: true,
            });
        }, 300),

        setanimationDurationOut(value) {

            this.$store.dispatch("setCurrentObjectProperties", { animationDurationOut: parseInt(value) });

        },
        // isLoopAnimation(value) {

        //     this.$store.dispatch("setCurrentObjectProperties", { animationLoop: value });

        //     this.disabledLoopAnimation = !value;

        //     if (!value) {
        //         this.$store.dispatch("setCurrentObjectProperties", {
        //             animationClassLoop: "",
        //         });
        //     }
        // },
        setanimationLoopDuration(value) {

            this.$store.dispatch("setCurrentObjectProperties", { animationLoopDuration: parseInt(value) });

        },
        disbledinanimation(value) {
            console.log("inanimation")
            console.log(value)
            // this.disabledinanimation = value;
            // this.getActiveObj.isInAnimationActive = value
            if (!value) {
                // If disabling animation, set class to empty
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClassIn: "",
                    isInAnimationActive: value,
                });
            } else {
                // If enabling animation, only update the active state
                this.$store.dispatch("setCurrentObjectProperties", {
                    isInAnimationActive: value,
                });
            }
        },
        disabledOutAnimation(out) {
            const currentObj = this.getActiveObj;

            if (!out) {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClassOut: "",
                    isOutAnimationActive: out,
                    isOutDelayManuallySet: false,
                });
            } else {
                let newOutDelay = currentObj.animationDelayOut;

                if (!currentObj.isOutDelayManuallySet) {
                    const delayIn = currentObj.animationDelayIn || 0;
                    const durationIn = currentObj.animationDurationIn || 0;
                    newOutDelay = delayIn + durationIn + 1;
                }

                this.$store.dispatch("setCurrentObjectProperties", {
                    isOutAnimationActive: out,
                    animationDelayOut: newOutDelay,
                });
            }
        },

        disabledLoopAnimation(loop) {
            console.log("outer", loop);

            if (!loop) {
                // Reset animation only when disabling
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClassLoop: "",
                    isLoopAnimationActive: loop,
                });
            } else {
                // If enabling, don't reset the animation class
                this.$store.dispatch("setCurrentObjectProperties", {
                    isLoopAnimationActive: loop,
                });
            }
        }


    }

}
</script>
<style scoped>
.line hr {
    margin-top: 30px;
    margin-bottom: 30px;
}
</style>